import type { LocationMapItem } from './Map/ListingMap';

export interface GoogleMapPinProps {
    // eslint-disable-next-line react/no-unused-prop-types
    lat?: number;
    // eslint-disable-next-line react/no-unused-prop-types
    lng?: number;
    style?: React.CSSProperties;
}


export const filterItemsById = (
    items: LocationMapItem[],
    activeItemId: string
): LocationMapItem[] => {
    return items.filter(({ id }) => {
        return id === activeItemId;
    });
};
